import React from "react";
import { TableHeadersType } from "../../../../constant/tableHeadersConstants/tableHeadersType";
import {
  currencySignAndNegativeValueAdjust,
  formatDate,
  reverseDate,
} from "../../../../utils/commonFunctions";
import { Link } from "react-router-dom";
import { GeneralLedgerListDataType } from "../../../../redux/reports/reportsType";

type AppProps = {
  tableHeaders: TableHeadersType[];
  tableData: GeneralLedgerListDataType[] | [];
  clientCode: number;
  companyName: string;
  startDate: string;
  endDate: string;
  currencySign: string | undefined;
  isLedgerStatementPresent?: boolean;
};
const GeneralLedgerTableData = ({
  tableHeaders,
  tableData,
  clientCode,
  companyName,
  startDate,
  endDate,
  currencySign,
  isLedgerStatementPresent,
}: AppProps) => {
  //redirection to ledger statement

  const finalRedirectLink = {
    pathname: `/reports/${clientCode}/ledger-statement?client_code=${clientCode}&company_name=${companyName}`,
  };

  const handleSetLocalStorageData = (ledgerId: number) => {
    localStorage.setItem("ledger_id", ledgerId.toString());
    localStorage.setItem("start_date", reverseDate(startDate));
    localStorage.setItem("end_date", reverseDate(endDate));
  };

  return (
    <>
      {tableData?.length > 0 &&
        tableData.map((ledger: any) => {
          return (
            <>
              <tr
                className="text-start"
                style={{ backgroundColor: "#e8ecf0" }}
                key={ledger?.primary_ledger_id}
              >
                <td
                  colSpan={5}
                  style={{
                    borderLeft: "none",
                    borderRight: "none",
                    whiteSpace: "nowrap",
                  }}
                >
                  {isLedgerStatementPresent ? (
                    <Link
                      target="_blank"
                      to={finalRedirectLink}
                      onClick={() =>
                        handleSetLocalStorageData(ledger?.primary_ledger_id)
                      }
                      style={{ textDecoration: "none", cursor: "pointer" }}
                    >
                      <span
                        style={{
                          textDecoration: "underline",
                          fontSize: "15px",
                          textUnderlineOffset: "0.3em",
                          color: "#262a44",
                          fontWeight: "500",
                          marginRight: "35px",
                          // whiteSpace: "nowrap",
                        }}
                      >
                        {ledger?.primary_ledger_name
                          ? ledger?.primary_ledger_name
                          : "N/A"}
                      </span>
                    </Link>
                  ) : (
                    <span
                      style={{
                        fontSize: "15px",
                        textUnderlineOffset: "0.3em",
                        color: "#262a44",
                        marginRight: "35px",
                      }}
                    >
                      {ledger?.primary_ledger_name
                        ? ledger?.primary_ledger_name
                        : "N/A"}{" "}
                    </span>
                  )}
                  <span
                    style={{
                      color: "#6e7491",
                      fontSize: "13px",
                      fontWeight: "500",
                    }}
                  >
                    {`(Unique Number: ${ledger?.details[0]?.primary_ledger_unique_number})`}
                  </span>
                </td>
                <td style={{ borderLeft: "none", borderRight: "none" }}>
                  {currencySignAndNegativeValueAdjust(
                    currencySign,
                    ledger?.total_debit_amount
                      ? ledger?.total_debit_amount?.toFixed(2)?.toString()
                      : "00.00"
                  )}
                </td>
                <td style={{ borderLeft: "none", borderRight: "none" }}>
                  {currencySignAndNegativeValueAdjust(
                    currencySign,
                    ledger?.total_credit_amount
                      ? ledger?.total_credit_amount?.toFixed(2)?.toString()
                      : "00.00"
                  )}
                </td>
                <td style={{ borderLeft: "none", borderRight: "none" }}></td>
              </tr>
              {ledger?.details?.map((detail: any, index: any) => (
                <tr key={index}>
                  <td
                    style={{
                      borderLeft: "none",
                      borderRight: "none",
                      minWidth: "150px",
                    }}
                  >
                    {detail?.date ? formatDate(detail.date) : ""}
                  </td>
                  <td style={{ borderLeft: "none", borderRight: "none" }}>
                    {isLedgerStatementPresent ? (
                      <Link
                        target="_blank"
                        to={finalRedirectLink}
                        onClick={() =>
                          handleSetLocalStorageData(detail?.involved_ledger_id)
                        }
                        style={{ textDecoration: "none", cursor: "pointer" }}
                      >
                        <span
                          style={{
                            textDecoration: "underline",
                            fontSize: "14px",
                            textUnderlineOffset: "0.3em",
                            color: "#262a44",
                            fontWeight: "500",
                            marginRight: "35px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {detail?.involved_ledger_name
                            ? detail?.involved_ledger_name
                            : "N/A"}
                        </span>
                      </Link>
                    ) : (
                      <span
                        style={{
                          fontSize: "14px",
                          textUnderlineOffset: "0.3em",
                          color: "#262a44",
                          marginRight: "35px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {detail?.involved_ledger_name
                          ? detail?.involved_ledger_name
                          : "N/A"}
                      </span>
                    )}
                  </td>
                  <td style={{ borderLeft: "none", borderRight: "none" }}>
                    {detail?.invoice_no ? detail.invoice_no : "--/--"}
                  </td>
                  <td style={{ borderLeft: "none", borderRight: "none" }}>
                    {detail?.narration ? detail.narration : "--/--"}
                  </td>

                  <td
                    style={{
                      borderLeft: "none",
                      borderRight: "none",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {detail?.voucher_type === 1
                      ? "Expense"
                      : detail?.voucher_type === 2
                      ? "Sales"
                      : "Other"}{" "}
                    Entry
                  </td>
                  <td style={{ borderLeft: "none", borderRight: "none" }}>
                    {currencySignAndNegativeValueAdjust(
                      currencySign,
                      detail?.debit_amount
                        ? detail?.debit_amount?.toString()
                        : "00.00"
                    )}
                  </td>
                  <td style={{ borderLeft: "none", borderRight: "none" }}>
                    {currencySignAndNegativeValueAdjust(
                      currencySign,
                      detail?.credit_amount
                        ? detail?.credit_amount?.toString()
                        : "00.00"
                    )}
                  </td>
                  <td style={{ borderLeft: "none", borderRight: "none" }}>
                    {currencySignAndNegativeValueAdjust(
                      currencySign,
                      detail?.balance ? detail?.balance?.toString() : "00.00"
                    )}
                  </td>
                </tr>
              ))}
            </>
          );
        })}
    </>
  );
};

export default GeneralLedgerTableData;
